import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import VMSComponent from '../components/VMSComponent';

import { getBuildingsForFilter } from '../../Building/actionCreators';

import { sortByKey } from '../../../utils';

const VMSContainer = (props) => {
  const { onLoad, ...rest } = props;

  useEffect(() => {
    onLoad();
  }, []);

  return <VMSComponent {...rest} />;
};

VMSContainer.propTypes = {
  onLoad: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { buildings } = state;
  const pmcId = ownProps?.pmc?.id;
  const buildingId = ownProps?.building?.id;

  let buildingsList = Object.values(buildings).sort((a, b) =>
    sortByKey(a, b, 'name'),
  );

  if (pmcId) {
    buildingsList = buildingsList?.filter(({ parent }) => parent?.id === pmcId);
  }
  if (buildingId) {
    buildingsList = buildingsList?.filter(({ id }) => id === buildingId);
  }

  const buildingsID = buildingsList?.map(({ id }) => id);

  return {
    buildings: buildingsList,
    buildingsID,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const buildingId = ownProps?.building?.id;
  const pmcId = ownProps?.pmc?.id;
  const queryParams = { disable_pagination: true };
  if (pmcId) {
    queryParams.pmc = pmcId;
  }
  return {
    onLoad: () => !buildingId && getBuildingsForFilter(dispatch, queryParams),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VMSContainer);
